function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 14.5,
  cy: 14.5,
  r: 14.5,
  fill: "#19A664"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 14.5l5.296 5.5L21 9",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "70%",
    viewBox: "0 0 29 29",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjcwJSIgd2lkdGg9IjEwMCUiICB2aWV3Qm94PSIwIDAgMjkgMjkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8Y2lyY2xlIGN4PSIxNC41IiBjeT0iMTQuNSIgcj0iMTQuNSIgZmlsbD0iIzE5QTY2NCIvPgogICAgPHBhdGggZD0iTTggMTQuNUwxMy4yOTYzIDIwTDIxIDkiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=";
export { SvgCheckmark as ReactComponent };